import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Accordion, Button } from "react-bootstrap";

// img
import styled from "styled-components";

const Sidebar = ({ sidebar, setSidebar }) => {
  const location = useLocation();
  const pageActive = location.pathname;
  const handleSidebar = () => {
    setSidebar(!sidebar);
  };
  const [confirmation, setConfirmation] = useState(false);

  const handleConfirmation = () => {
    setConfirmation(true);
  };

  const confirmHandler = () => {
    // Handle logout logic here
    setConfirmation(false);
  };
  // console.log(sidebar, "sidebarcheck");
  return (
    <>
      <SidebarWrp sidebar={sidebar} className={` pt-4 position-fixed`}>
        <Button
          onClick={handleSidebar}
          variant="transparent"
          className="position-absolute border-0 p-2 closeBtn d-lg-none"
          style={{ top: 0, right: 0 }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="21"
            viewBox="0 0 15 21"
            fill="none"
          >
            <path
              d="M7.245 6.529L10.668 1.3H14.259V1.447L9.303 8.608L14.343 15.895V16H10.71L7.245 10.834L3.78 16H0.147V15.895L5.145 8.608L0.21 1.447V1.3H3.801L7.245 6.529Z"
              fill="#fff"
            />
          </svg>
        </Button>
        <div className={` top px-3 py-2`}>
          <h4 className="m-0 fw-normal text-white pb-3">Main</h4>
        </div>
        <LinkWrpper
          className={`d-flex flex-column justify-content-between  pt-2 px-3 `}
        >
          <div className="top w-100">
            <ul className="list-unstyled ps-0 mb-0">
              {/* <li className="">
              <NavLink
                to="/dashboard"
                className={` ${
                  pageActive.includes("/dashboard") && "active"
                } d-flex align-items-center gap-10 `}
              >
                <span className={` icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2.8 1H2.75C2.521 1 2.324 1 2.15 1.041C1.88064 1.10536 1.63435 1.24305 1.43843 1.43879C1.24251 1.63453 1.10461 1.88069 1.04 2.15C1 2.324 1 2.52 1 2.75V5.25C1 5.479 1 5.676 1.041 5.85C1.10536 6.11936 1.24305 6.36565 1.43879 6.56157C1.63453 6.75749 1.88069 6.89539 2.15 6.96C2.324 7 2.52 7 2.75 7H5.25C5.479 7 5.676 7 5.85 6.959C6.11936 6.89464 6.36565 6.75695 6.56157 6.56121C6.75749 6.36547 6.89539 6.11931 6.96 5.85C7 5.676 7 5.48 7 5.25V2.75C7 2.521 7 2.324 6.959 2.15C6.89464 1.88064 6.75695 1.63435 6.56121 1.43843C6.36547 1.24251 6.11931 1.10461 5.85 1.04C5.676 1 5.48 1 5.25 1H5.2H2.8ZM2.383 2.014C2.426 2.004 2.493 2 2.8 2H5.2C5.508 2 5.574 2.003 5.617 2.014C5.70683 2.03548 5.78895 2.08143 5.85426 2.14674C5.91957 2.21205 5.96552 2.29417 5.987 2.384C5.997 2.426 6 2.492 6 2.8V5.2C6 5.508 5.997 5.574 5.986 5.617C5.96452 5.70683 5.91857 5.78895 5.85326 5.85426C5.78795 5.91957 5.70583 5.96552 5.616 5.987C5.575 5.996 5.509 6 5.2 6H2.8C2.492 6 2.426 5.997 2.383 5.986C2.29317 5.96452 2.21105 5.91857 2.14574 5.85326C2.08043 5.78795 2.03448 5.70583 2.013 5.616C2.004 5.575 2 5.509 2 5.2V2.8C2 2.492 2.003 2.426 2.014 2.383C2.03548 2.29317 2.08143 2.21105 2.14674 2.14574C2.21205 2.08043 2.29417 2.03448 2.384 2.013M9.8 1H9.75C9.521 1 9.324 1 9.15 1.041C8.88064 1.10536 8.63435 1.24305 8.43843 1.43879C8.24251 1.63453 8.10461 1.88069 8.04 2.15C8 2.324 8 2.52 8 2.75V5.25C8 5.479 8 5.676 8.041 5.85C8.10537 6.11936 8.24305 6.36565 8.43879 6.56157C8.63453 6.75749 8.88069 6.89539 9.15 6.96C9.324 7 9.52 7 9.75 7H12.25C12.479 7 12.676 7 12.85 6.959C13.1194 6.89464 13.3657 6.75695 13.5616 6.56121C13.7575 6.36547 13.8954 6.11931 13.96 5.85C14 5.676 14 5.48 14 5.25V2.75C14 2.521 14 2.324 13.959 2.15C13.8946 1.88064 13.757 1.63435 13.5612 1.43843C13.3655 1.24251 13.1193 1.10461 12.85 1.04C12.676 1 12.48 1 12.25 1H12.2H9.8ZM9.383 2.014C9.426 2.004 9.493 2 9.8 2H12.2C12.508 2 12.574 2.003 12.617 2.014C12.7068 2.03548 12.789 2.08143 12.8543 2.14674C12.9196 2.21205 12.9655 2.29417 12.987 2.384C12.997 2.426 13 2.492 13 2.8V5.2C13 5.508 12.996 5.574 12.986 5.617C12.9645 5.70683 12.9186 5.78895 12.8533 5.85426C12.788 5.91957 12.7058 5.96552 12.616 5.987C12.574 5.997 12.508 6 12.2 6H9.8C9.492 6 9.426 5.997 9.383 5.986C9.29317 5.96452 9.21105 5.91857 9.14574 5.85326C9.08043 5.78795 9.03448 5.70583 9.013 5.616C9.004 5.575 9 5.509 9 5.2V2.8C9 2.492 9.003 2.426 9.014 2.383C9.03548 2.29317 9.08142 2.21105 9.14674 2.14574C9.21205 2.08043 9.29417 2.03448 9.384 2.013M2.75 8H5.25C5.479 8 5.676 8 5.85 8.041C6.11936 8.10537 6.36565 8.24305 6.56157 8.43879C6.75749 8.63453 6.89539 8.88069 6.96 9.15C7 9.324 7 9.52 7 9.75V12.25C7 12.479 7 12.676 6.959 12.85C6.89464 13.1194 6.75695 13.3657 6.56121 13.5616C6.36547 13.7575 6.11931 13.8954 5.85 13.96C5.676 14 5.48 14 5.25 14H2.75C2.521 14 2.324 14 2.15 13.959C1.88064 13.8946 1.63435 13.757 1.43843 13.5612C1.24251 13.3655 1.10461 13.1193 1.04 12.85C1 12.676 1 12.48 1 12.25V9.75C1 9.521 1 9.324 1.041 9.15C1.10536 8.88064 1.24305 8.63435 1.43879 8.43843C1.63453 8.24251 1.88069 8.10461 2.15 8.04C2.324 8 2.52 8 2.75 8ZM2.8 9C2.492 9 2.426 9.003 2.383 9.014C2.29317 9.03548 2.21105 9.08142 2.14574 9.14674C2.08043 9.21205 2.03448 9.29417 2.013 9.384C2.004 9.425 2 9.491 2 9.8V12.2C2 12.508 2.003 12.574 2.014 12.617C2.03548 12.7068 2.08143 12.789 2.14674 12.8543C2.21205 12.9196 2.29417 12.9655 2.384 12.987C2.426 12.997 2.492 13 2.8 13H5.2C5.508 13 5.574 12.996 5.617 12.986C5.70683 12.9645 5.78895 12.9186 5.85426 12.8533C5.91957 12.788 5.96552 12.7058 5.987 12.616C5.997 12.574 6 12.508 6 12.2V9.8C6 9.492 5.997 9.426 5.986 9.383C5.96452 9.29317 5.91857 9.21105 5.85326 9.14574C5.78795 9.08043 5.70583 9.03448 5.616 9.013C5.575 9.004 5.509 9 5.2 9H2.8ZM9.8 8H9.75C9.521 8 9.324 8 9.15 8.041C8.88064 8.10537 8.63435 8.24305 8.43843 8.43879C8.24251 8.63453 8.10461 8.88069 8.04 9.15C8 9.324 8 9.52 8 9.75V12.25C8 12.479 8 12.676 8.041 12.85C8.10537 13.1194 8.24305 13.3657 8.43879 13.5616C8.63453 13.7575 8.88069 13.8954 9.15 13.96C9.324 14.001 9.521 14.001 9.75 14.001H12.25C12.479 14.001 12.676 14.001 12.85 13.96C13.1192 13.8955 13.3653 13.7577 13.561 13.562C13.7567 13.3663 13.8945 13.1202 13.959 12.851C14 12.677 14 12.48 14 12.251V9.75C14 9.521 14 9.324 13.959 9.15C13.8946 8.88064 13.757 8.63435 13.5612 8.43843C13.3655 8.24251 13.1193 8.10461 12.85 8.04C12.676 8 12.48 8 12.25 8H12.2H9.8ZM9.383 9.014C9.426 9.004 9.493 9 9.8 9H12.2C12.508 9 12.574 9.003 12.617 9.014C12.7068 9.03548 12.789 9.08142 12.8543 9.14674C12.9196 9.21205 12.9655 9.29417 12.987 9.384C12.997 9.426 13 9.492 13 9.8V12.2C13 12.508 12.996 12.574 12.986 12.617C12.9645 12.7068 12.9186 12.789 12.8533 12.8543C12.788 12.9196 12.7058 12.9655 12.616 12.987C12.574 12.997 12.508 13 12.2 13H9.8C9.492 13 9.426 12.996 9.383 12.986C9.29317 12.9645 9.21105 12.9186 9.14574 12.8533C9.08043 12.788 9.03448 12.7058 9.013 12.616C9.004 12.575 9 12.509 9 12.2V9.8C9 9.492 9.003 9.426 9.014 9.383C9.03548 9.29317 9.08142 9.21105 9.14674 9.14574C9.21205 9.08043 9.29417 9.03448 9.384 9.013"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                Dashboard
              </NavLink>
            </li> */}
              <li className="">
                <Accordion.Item
                  className={` border-0 bg-transparent`}
                  eventKey="0"
                >
                  <Accordion.Header
                    className={` fw-bold d-flex align-items-center gap-10`}
                  >
                    Version Soothesayer 3.5
                  </Accordion.Header>
                  <Accordion.Body className="pb-0 pt-2 px-0">
                    <ul className="list-unstyled ps-0 mb-0">
                      <li className="py-1">
                        <NavLink
                          to=""
                          className={`link d-flex align-items-center gap-10 py-1 text-white`}
                        >
                          <span className="icn">{checkIcn}</span>
                          Show resource-link
                        </NavLink>
                      </li>
                      <li className="py-1">
                        <NavLink
                          to=""
                          className={`link d-flex align-items-center gap-10 py-1 text-white`}
                        >
                          <span className="icn">{checkIcn}</span>
                          Show proposed prompt
                        </NavLink>
                      </li>
                      <li className="py-1">
                        <NavLink
                          to=""
                          className={`link d-flex align-items-center gap-10 py-1 text-white`}
                        >
                          <span className="icn">{uncheckedIcn}</span>
                          Dark mode
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </li>
              <li className=""></li>
            </ul>
          </div>
          <div className="bottom w-100">
            <TabsNav className="border rounded-3 p-1 d-flex align-items-center">
              <Button
                variant="transaprent"
                className="border-0 rounded-3 w-100 d-flex align-items-center justify-content-center"
              >
                <span className="icn me-2">{historyIcn}</span>
                History
              </Button>
              <Button
                variant="transaprent"
                className="border-0 active rounded-3 w-100 d-flex align-items-center justify-content-center"
              >
                <span className="icn me-2">{chatIcn}</span>
                Main
              </Button>
            </TabsNav>
          </div>
        </LinkWrpper>
      </SidebarWrp>
    </>
  );
};

const SidebarWrp = styled.div`
  height: 100vh;
  width: 279px;
  border-right: 1px solid #393939;
  z-index: 9999;
  transition: 0.4s;
  @media (max-width: 992px) {
    transform: ${({ sidebar }) =>
      sidebar ? "translateX(0%)" : "translateX(-110%)"};
    background: linear-gradient(318.39deg, #355e3b 15.7%, #0f0b41 84.3%);
  }
`;

const TabsNav = styled.div`
  button {
    color: #767676;
    transition: 0.4s;
    font-size: 13px;
    height: 45px;
    &.active {
      background: #fff;
      color: #000;
    }
  }
`;

const LinkWrpper = styled(Accordion)`
  height: calc(100vh - 90px);
  .accordion-button {
    background: transparent;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid #393939;
    padding: 10px;
    border-radius: 8px !important;
    box-shadow: unset !important;
  }
  a.link {
    font-size: 12px;
    font-weight: 500;
  }
`;

export default Sidebar;

const checkIcn = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#5CBD3A" />
    <path
      d="M6.48795 11.5999C6.40463 11.5999 6.32392 11.5838 6.24581 11.5515C6.1677 11.5192 6.0922 11.4654 6.01929 11.39L3.37918 8.66179C3.25421 8.53264 3.19432 8.36851 3.19953 8.16941C3.20474 7.97031 3.26983 7.80618 3.39481 7.67703C3.51978 7.54788 3.676 7.48331 3.86346 7.48331C4.05093 7.48331 4.20715 7.54788 4.33212 7.67703L6.5192 9.93712L11.6901 4.59362C11.815 4.46448 11.9687 4.3999 12.1509 4.3999C12.3332 4.3999 12.4868 4.46448 12.6118 4.59362C12.7367 4.72277 12.7992 4.88152 12.7992 5.06986C12.7992 5.2582 12.7367 5.41694 12.6118 5.54609L6.95661 11.39C6.88371 11.4654 6.8082 11.5192 6.73009 11.5515C6.65198 11.5838 6.57127 11.5999 6.48795 11.5999Z"
      fill="white"
    />
  </svg>
);

const uncheckedIcn = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9"
      cy="9"
      r="8"
      stroke="#D4D3D3"
      stroke-linecap="round"
      stroke-dasharray="3 3"
    />
  </svg>
);

const historyIcn = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.59961 2.89999C5.38744 2.89999 5.18395 2.98428 5.03392 3.13431C4.88389 3.28434 4.79961 3.48782 4.79961 3.69999C4.79961 3.91217 4.88389 4.11565 5.03392 4.26568C5.18395 4.41571 5.38744 4.49999 5.59961 4.49999H10.3996C10.6118 4.49999 10.8153 4.41571 10.9653 4.26568C11.1153 4.11565 11.1996 3.91217 11.1996 3.69999C11.1996 3.48782 11.1153 3.28434 10.9653 3.13431C10.8153 2.98428 10.6118 2.89999 10.3996 2.89999H5.59961ZM3.19961 6.09999C3.19961 5.88782 3.28389 5.68434 3.43392 5.53431C3.58395 5.38428 3.78744 5.29999 3.99961 5.29999H11.9996C12.2118 5.29999 12.4153 5.38428 12.5653 5.53431C12.7153 5.68434 12.7996 5.88782 12.7996 6.09999C12.7996 6.31217 12.7153 6.51565 12.5653 6.66568C12.4153 6.81571 12.2118 6.89999 11.9996 6.89999H3.99961C3.78744 6.89999 3.58395 6.81571 3.43392 6.66568C3.28389 6.51565 3.19961 6.31217 3.19961 6.09999ZM1.59961 9.29999C1.59961 8.87565 1.76818 8.46868 2.06824 8.16862C2.3683 7.86857 2.77526 7.69999 3.19961 7.69999H12.7996C13.224 7.69999 13.6309 7.86857 13.931 8.16862C14.231 8.46868 14.3996 8.87565 14.3996 9.29999V12.5C14.3996 12.9243 14.231 13.3313 13.931 13.6314C13.6309 13.9314 13.224 14.1 12.7996 14.1H3.19961C2.77526 14.1 2.3683 13.9314 2.06824 13.6314C1.76818 13.3313 1.59961 12.9243 1.59961 12.5V9.29999Z"
      fill="currentColor"
    />
  </svg>
);

const chatIcn = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.59961 4.49999C1.59961 4.07565 1.76818 3.66868 2.06824 3.36862C2.3683 3.06856 2.77526 2.89999 3.19961 2.89999H8.79961C9.22396 2.89999 9.63092 3.06856 9.93098 3.36862C10.231 3.66868 10.3996 4.07565 10.3996 4.49999V7.69999C10.3996 8.12434 10.231 8.53131 9.93098 8.83136C9.63092 9.13142 9.22396 9.29999 8.79961 9.29999H7.19961L4.79961 11.7V9.29999H3.19961C2.77526 9.29999 2.3683 9.13142 2.06824 8.83136C1.76818 8.53131 1.59961 8.12434 1.59961 7.69999V4.49999Z"
      fill="currentColor"
    />
    <path
      d="M11.9996 6.10001V7.70001C11.9996 8.5487 11.6625 9.36263 11.0624 9.96275C10.4622 10.5629 9.64831 10.9 8.79962 10.9H7.86202L6.44922 12.3136C6.67322 12.4328 6.92842 12.5 7.19962 12.5H8.79962L11.1996 14.9V12.5H12.7996C13.224 12.5 13.6309 12.3314 13.931 12.0314C14.231 11.7313 14.3996 11.3244 14.3996 10.9V7.70001C14.3996 7.27566 14.231 6.86869 13.931 6.56864C13.6309 6.26858 13.224 6.10001 12.7996 6.10001H11.9996Z"
      fill="currentColor"
    />
  </svg>
);
